import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const TextEditor = ({ initialValue, onChange }) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: [] }],
      ["link"],
      ["clean"],
      [{ color: [] }, { background: [] }],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "align",
    "link",
    "color",
    "background",
  ];
  
  return (
    <ReactQuill
      theme="snow"
      value={initialValue || ""}
      onChange={onChange}
      modules={modules}
      formats={formats}
      style={{ height: "200px", marginBottom: "50px" }}
    />
  );
};

export default TextEditor;
